import React, { Component } from "react";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import hw from "../../Images/hw.svg";
import lc from "../../Images/lc.svg";
import oc from "../../Images/oc.svg";
import diary from "../../Images/diary.svg";
import notifs from "../../Images/notifs.svg";
import events from "../../Images/events.svg";
import gallery from "../../Images/gallery.svg";
import holidays from "../../Images/holidays.svg";
import payments from "../../Images/payments.svg";
import complaints from "../../Images/complaints.svg";
import assessment from "../../Images/assessment.svg";
import assignments from "../../Images/assignments.svg";
import attendence from "../../Images/attendence.svg";
import downloads from "../../Images/downloads.svg";
import results from "../../Images/results.svg";
import exams from "../../Images/exams.svg";
import dp from "../../Images/dp.svg";
import { Link } from "react-router-dom";
import HeaderV2 from "../../Layout/Header";
import HomeProfileCardV2 from "../../Components/Home/ProfileCardV2";
import Skeleton from "react-loading-skeleton";
import Axios from "axios";
import Authorize from "../../../../global/Authorize";
import BirthdayCard from "../../../Components/Birthday/BirthdayCard";
import Cover from "../../../Assets/img/default-cover-image.svg";

const mapStateToProps = ({ dispatch, user }) => ({
  dispatch,
  user,
});

const HeadList = [
  {
    route: "/homeWork",
    image: hw,
    label: "Homework",
  },
  {
    route: "/onlineclass",
    image: lc,
    label: "Live Class",
  },
  {
    route: "/payments",
    image: payments,
    label: "Payments",
  },
];
const BodyList = [
  {
    route: "/gallery",
    image: gallery,
    label: "Gallery",
  },
  {
    route: "/events",
    image: events,
    label: "Events",
  },
  {
    route: "/holidays",
    image: holidays,
    label: "Holidays",
  },
  {
    route: "/notifications",
    image: notifs,
    label: "Notifications",
  },

  {
    route: "/prevComplaint",
    image: complaints,
    label: "Complaints",
  },
  {
    route: "/attstudent",
    image: attendence,
    label: "Attendence",
  },
  {
    route: "/results",
    image: results,
    label: "Results",
  },
  {
    route: "/examSchedule",
    image: exams,
    label: "Exam Schedule",
  },
  {
    route: "/exam-questions",
    image: results,
    label: "Online Exam",
  },
];

function HeadTab(props) {
  return (
    <>
      <Link to={props.route}>
        <div
          className="mx-auto text-center th-br-12"
          style={{
            opacity: "0.9",
          }}
        >
          <img
            src={props.image}
            alt=""
            style={{
              background:
                "linear-gradient(180deg, rgba(255, 255, 255, 0.42) 0%, rgba(255, 255, 255, 0.16) 100%)",
            }}
            className="p-2 th-br-12 shadow-sm"
          />
        </div>
        <div
          className="my-2 th-fw-600 th-12 text-center"
          style={{ color: "#FFFFFF", opacity: "0.8" }}
        >
          {props.label}
        </div>
      </Link>
    </>
  );
}

function BodyTab(props) {
  return (
    <>
      {/* <div className="d-flex flex-column mx-auto col-3 p-0"> */}
      <Link to={props.route} className="d-flex flex-column p-0">
        <div className="mx-auto th-br-12 shadow-sm">
          <img
            src={props.image}
            style={{
              background:
                "linear-gradient(to right, #314755 0%, #26a0da  51%, #314755  100%)",
            }}
            alt=""
            className="p-2 th-br-12 shadow-sm"
          />
        </div>
        <div
          className="my-2 th-fw-600 th-12 text-center"
          style={{ color: "#000000" }}
        >
          {props.label}
        </div>
      </Link>
      {/* </div> */}
    </>
  );
}

class StudentHomeV2 extends Component {
  constructor(props) {
    super(props);

    var today = new Date(),
      date =
        today.getFullYear() +
        "-" +
        ("0" + (today.getMonth() + 1)).slice(-2) +
        "-" +
        ("0" + today.getDate()).slice(-2);

    this.state = {
      UpcomingEventData: [],
      loading: true,
      todayDate: date,
      fakeData: [1, 2, 3],
    };
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    document.title = "Home";

    var dt = new Date();

    this.fetchUpcomingEventData({
      school: this.props.user?.user?.school?.id,
      status: true,
      from_date__gte:
        dt.getFullYear() + "-" + (dt.getMonth() + 1) + "-" + dt.getDate(),
      session: this.props?.user?.student_info?.session?.id,
    });
    this.fetchUpcomingEventData({
      session: this.props?.user?.session?.id,
    });
  }

  fetchUpcomingEventData = (params = {}) => {
    Axios.get("/mApiV1/EventsList", { params: { ...params } })
      .then((res) => {
        this.setState({ UpcomingEventData: res.data, loading: false });
        // this.setState({ loading: false });
      })
      .catch((error) => {
        this.setState({ loading: false });
      });
  };

  render() {
    console.log(this, "this.props");
    const handelDt = (dt) => {
      var j = dt % 10,
        k = dt % 100;
      if (j === 1 && k !== 11) {
        return dt + "st";
      }
      if (j === 2 && k !== 12) {
        return dt + "nd";
      }
      if (j === 3 && k !== 13) {
        return dt + "rd";
      }
      return dt + "th";
    };
    const monthNames = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sept",
      "Oct",
      "Nov",
      "Dec",
    ];
    const handleDate = (date1, date2) => {
      let year1 = new Date(date1).getFullYear();
      let month1 = new Date(date1).getMonth();
      let dt1 = new Date(date1).getDate();

      let year2 = new Date(date2).getFullYear();
      let month2 = new Date(date2).getMonth();
      let dt2 = new Date(date2).getDate();

      year1 = year1 % 100;
      year2 = year2 % 100;
      if (year1 === year2) {
        if (month1 === month2) {
          if (dt1 === dt2) {
            return `${handelDt(dt1)} ${monthNames[month1]}, ${year1}`;
          } else {
            return `${handelDt(dt1)}-${handelDt(dt2)} ${
              monthNames[month1]
            }, ${year1}`;
          }
        } else {
          return `${handelDt(dt1)} ${monthNames[month1]} - ${handelDt(dt2)} ${
            monthNames[month2]
          }, ${year1}`;
        }
      } else {
        return `${handelDt(dt1)} ${monthNames[month1]}  ${year1} - ${handelDt(
          dt2
        )} ${monthNames[month2]}, ${year2}`;
      }
    };
    if (this.props.user.role.id !== 9) {
      return <Redirect to={"/teacherHomeV2"} />;
    }
    return (
      <Authorize roles={["IS_STUDENT"]} redirect to="/login">
        <HeaderV2 to="/home" title="Home" />
        <div className="">
          <div
            className="mb-3"
            style={{
              // width: "200%",
              overflow: "hidden",
              background:
                "linear-gradient(to right, #314755 0%, #26a0da  51%, #314755  100%)",
              borderBottomLeftRadius: "25%",
              borderBottomRightRadius: "25%",
              paddingBottom: "30px",
              // margin: "0px 0px  0px -50%",
            }}
          >
            <div>
              <HomeProfileCardV2 />
              <div className="row my-auto mx-auto">
                {HeadList?.map((eachHead) => {
                  return (
                    <div className="col-4">
                      <HeadTab
                        route={eachHead.route}
                        image={eachHead.image}
                        label={eachHead.label}
                      />
                    </div>
                  );
                })}
              </div>
            </div>
          </div>

          {this.props.user.studentData.date_of_birth ? (
            this.state.todayDate.slice(-5) ===
            this.props.user.studentData.date_of_birth.slice(-5) ? (
              <div className="px-3 pb-3">
                <BirthdayCard name={this.props.user.user.first_name} />
              </div>
            ) : null
          ) : null}

          <div>
            {this.state?.UpcomingEventData ? (
              <>
                <div className="container">
                  {this.state?.UpcomingEventData?.length !== 0 &&
                  this.state.loading === false ? (
                    <h5 className="th-16 mt-2 mb-3  text-center th-fw-600">
                      Upcoming Events
                    </h5>
                  ) : null}
                </div>
                <div
                  className="d-flex flex-row th-no-scroll"
                  style={{ overflowX: "scroll" }}
                >
                  {this.state.loading ? (
                    <>
                      {this.state.fakeData?.map((item, index) => (
                        <div key={index}>
                          <Skeleton
                            className="ml-3 overflow-hidden"
                            height={180}
                            width={240}
                          />
                        </div>
                      ))}
                      <div className="px-2"></div>
                    </>
                  ) : (
                    <>
                      {this.state.UpcomingEventData?.map((item, index) => (
                        <div key={index}>
                          <div
                            className="ml-3 overflow-hidden"
                            style={{
                              backgroundRepeat: "no-repeat",
                              backgroundSize: "cover",
                              backgroundPosition: "center",

                              backgroundImage: `url(${
                                item?.event_image ? item?.event_image : Cover
                              })`,

                              // backgroundImage: `url(${item.event_image})`,
                              borderRadius: 16,
                            }}
                          >
                            <div
                              className="d-flex align-items-end"
                              style={{
                                height: 180,
                                minWidth: 240,
                                width: 240,
                                padding: 16,
                                background:
                                  "linear-gradient(360deg, rgba(0, 0, 0, 0.81) 0%, rgba(0, 0, 0, 0.400781) 31.77%, rgba(0, 0, 0, 0) 100%)",
                              }}
                            >
                              <div className="">
                                <h6
                                  className="th-14 mb-0 text-white"
                                  style={{ width: 180 }}
                                >
                                  {item?.event_name}
                                </h6>
                                <p
                                  className="th-12 text-truncate mb-0 text-light"
                                  style={{ width: 208 }}
                                >
                                  {handleDate(item?.from_date, item?.to_date)}
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      ))}

                      <div className="px-2"></div>
                    </>
                  )}
                </div>
              </>
            ) : null}
          </div>

          <div className="container th-16  mt-4 mb-2 th-fw-600 text-center">
            Explore
          </div>

          <div className="row px-3 my-3">
            {BodyList.map((eachTab, i) => {
              return (
                <div className="col-4 mb-4">
                  <BodyTab
                    route={eachTab.route}
                    image={eachTab.image}
                    label={eachTab.label}
                  />
                </div>
              );
            })}
          </div>
        </div>
      </Authorize>
    );
  }
}

export default connect(mapStateToProps)(StudentHomeV2);
